import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { actions, selectors } from 'src/store';
import { paths } from 'src/constants';
import { useIntlMessages } from 'src/hooks';

import { Container } from './components';

const MemoryStepTwoCollections = ({
  getCollectionsByGroupId,
  hasLoaded,
  memoryStepTwoCollections,
  memoryStepTwoCurrency,
  pageCount,
}) => {
  const messages = useIntlMessages();

  return (
    <Container
      className="memory-collections-container--step-two"
      collectionsPath={paths.MEMORY_STEP_TWO_COLLECTIONS}
      currency={memoryStepTwoCurrency}
      getCollectionsByGroupId={getCollectionsByGroupId}
      hasLoaded={hasLoaded}
      items={memoryStepTwoCollections}
      levelsPath={paths.MEMORY_STEP_TWO_LEVELS}
      pageCount={pageCount}
      title={messages.game.memory}
    />
  );
};

MemoryStepTwoCollections.propTypes = {
  getCollectionsByGroupId: PropTypes.func.isRequired,
  hasLoaded: PropTypes.bool.isRequired,
  memoryStepTwoCollections: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  memoryStepTwoCurrency: PropTypes.shape({}).isRequired,
  pageCount: PropTypes.number.isRequired,
};

const mapStateToProps = (state) => ({
  hasLoaded: selectors.memoryStepTwoCollections.getHasLoaded(state),
  memoryStepTwoCurrency: selectors.memoryStepTwoCollections.getCurrencyData(
    state
  ),
  memoryStepTwoCollections: selectors.memoryStepTwoCollections.getCollectionsData(
    state
  ),
  pageCount: selectors.memoryStepTwoCollections.getPageCount(state),
});

const mapDispatchToProps = {
  ...actions.memoryStepTwo,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  memo
)(MemoryStepTwoCollections);
